import React, { memo, useCallback } from 'react';
import { prefsIds } from 'settings/constants/preferences';
import PropTypes from 'prop-types';

const Icon = memo(({ className, variant, color }) => {
  const getIcon = useCallback(() => {
    switch (variant) {
      case Icon.MOVE_IN_READY:
        return (
          <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M31.6306 33.0346L32.0379 31.8528C31.5859 31.697 31.0847 31.8127 30.7467 32.1507L31.6306 33.0346ZM22.968 24.373L23.8519 25.2569C24.19 24.9188 24.3056 24.4176 24.1498 23.9656L22.968 24.373ZM7.12413 41.6667L8.37413 41.6667L8.37413 41.6667L7.12413 41.6667ZM7.12413 45.379L5.87413 45.379L5.87413 45.379L7.12413 45.379ZM10.6241 48.879L10.6241 47.629L10.6241 47.629V48.879ZM14.3364 48.879L14.3364 47.629L14.3364 47.629V48.879ZM17.6427 47.0224L18.5266 47.9063C18.761 47.6719 18.8927 47.354 18.8927 47.0224H17.6427ZM17.6427 42.0731L17.6427 40.8231C16.9524 40.8231 16.3927 41.3827 16.3927 42.0731L17.6427 42.0731ZM22.5921 42.0731V43.3231C22.9236 43.3231 23.2416 43.1914 23.476 42.957L22.5921 42.0731ZM23.2106 41.4546L24.0945 42.3385C24.3289 42.104 24.4606 41.7861 24.4606 41.4546L23.2106 41.4546ZM23.2106 36.5044L23.2106 35.2544C22.8791 35.2544 22.5611 35.3861 22.3267 35.6205C22.0923 35.8549 21.9606 36.1728 21.9606 36.5044L23.2106 36.5044ZM28.1608 36.5044L28.1608 37.7544C28.4923 37.7544 28.8103 37.6227 29.0447 37.3882L28.1608 36.5044ZM45.2187 28.8146C41.6555 32.3778 36.5065 33.3929 32.0379 31.8528L31.2233 34.2164C36.5612 36.0561 42.7218 34.8471 46.9865 30.5824L45.2187 28.8146ZM45.2187 10.7834C50.1979 15.7626 50.1979 23.8354 45.2187 28.8146L46.9865 30.5824C52.942 24.6269 52.942 14.9711 46.9865 9.01561L45.2187 10.7834ZM27.1875 10.7834C32.1667 5.80419 40.2396 5.80419 45.2187 10.7834L46.9865 9.01561C41.031 3.06012 31.3752 3.06012 25.4197 9.01561L27.1875 10.7834ZM24.1498 23.9656C22.609 19.4967 23.624 14.3469 27.1875 10.7834L25.4197 9.01561C21.1546 13.2808 19.9458 19.4422 21.7863 24.7805L24.1498 23.9656ZM9.03314 40.0757L23.8519 25.2569L22.0842 23.4891L7.26537 38.3079L9.03314 40.0757ZM8.37413 41.6667C8.37413 41.0699 8.61118 40.4977 9.03314 40.0757L7.26537 38.3079C6.37457 39.1987 5.87413 40.4069 5.87413 41.6667L8.37413 41.6667ZM8.37413 45.379L8.37413 41.6667L5.87413 41.6667L5.87413 45.379L8.37413 45.379ZM10.6241 47.629C9.38149 47.629 8.37413 46.6216 8.37413 45.379L5.87413 45.379C5.87413 48.0023 8.00078 50.129 10.6241 50.129V47.629ZM14.3364 47.629L10.6241 47.629L10.6241 50.129H14.3364V47.629ZM15.9274 46.97C15.5055 47.3919 14.9332 47.629 14.3364 47.629L14.3364 50.129C15.5962 50.129 16.8044 49.6285 17.6952 48.7378L15.9274 46.97ZM16.7589 46.1386L15.9274 46.97L17.6952 48.7378L18.5266 47.9063L16.7589 46.1386ZM16.3927 42.0731L16.3927 47.0224H18.8927V42.0731L16.3927 42.0731ZM22.5921 40.8231L17.6427 40.8231L17.6427 43.3231H22.5921V40.8231ZM22.3267 40.5707L21.7082 41.1892L23.476 42.957L24.0945 42.3385L22.3267 40.5707ZM21.9606 36.5044L21.9606 41.4546L24.4606 41.4546L24.4606 36.5044L21.9606 36.5044ZM28.1608 35.2544L23.2106 35.2544L23.2106 37.7544L28.1608 37.7544L28.1608 35.2544ZM30.7467 32.1507L27.2769 35.6205L29.0447 37.3882L32.5145 33.9185L30.7467 32.1507Z"
              fill={color || '#515151'}
            />
            <circle
              cx="38.6777"
              cy="17.3247"
              r="3.5"
              transform="rotate(45 38.6777 17.3247)"
              stroke="#515151"
              strokeWidth="2.5"
            />
          </svg>
        );
      case Icon.NEW_CONSTRUCTION:
        return (
          <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.8379 28.9033V49.8807C10.8379 50.2673 11.1513 50.5807 11.5379 50.5807H44.4605C44.8471 50.5807 45.1605 50.2673 45.1605 49.8807V28.9033"
              stroke="#515151"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.3301 50.5806C21.3301 51.271 21.8897 51.8306 22.5801 51.8306C23.2704 51.8306 23.8301 51.271 23.8301 50.5806H21.3301ZM32.1688 50.5806C32.1688 51.271 32.7284 51.8306 33.4188 51.8306C34.1091 51.8306 34.6688 51.271 34.6688 50.5806H32.1688ZM23.8301 50.5806V37.7322H21.3301V50.5806H23.8301ZM23.2801 38.2822H32.7188V35.7822H23.2801V38.2822ZM32.1688 37.7322V50.5806H34.6688V37.7322H32.1688ZM32.7188 38.2822C32.415 38.2822 32.1688 38.036 32.1688 37.7322H34.6688C34.6688 36.6553 33.7957 35.7822 32.7188 35.7822V38.2822ZM23.8301 37.7322C23.8301 38.036 23.5838 38.2822 23.2801 38.2822V35.7822C22.2031 35.7822 21.3301 36.6553 21.3301 37.7322H23.8301Z"
              fill={color || '#515151'}
            />
            <path
              d="M6.43046 30.6492C5.89822 31.0889 5.82319 31.8768 6.26286 32.4091C6.70254 32.9413 7.49043 33.0163 8.02266 32.5767L6.43046 30.6492ZM47.9788 32.5767C48.5111 33.0163 49.299 32.9413 49.7387 32.4091C50.1783 31.8768 50.1033 31.0889 49.5711 30.6492L47.9788 32.5767ZM28.4466 14.8199L27.6505 15.7836L28.4466 14.8199ZM8.02266 32.5767L28.351 15.7836L26.7588 13.8562L6.43046 30.6492L8.02266 32.5767ZM27.6505 15.7836L47.9788 32.5767L49.5711 30.6492L29.2427 13.8562L27.6505 15.7836ZM28.351 15.7836C28.1477 15.9516 27.8538 15.9516 27.6505 15.7836L29.2427 13.8562C28.5218 13.2607 27.4797 13.2607 26.7588 13.8562L28.351 15.7836Z"
              fill={color || '#515151'}
            />
            <path
              d="M45.1612 1.80664C43.6558 7.82815 42.1504 9.33352 36.1289 10.8389C42.1504 12.3443 43.6558 13.8497 45.1612 19.8712C46.6665 13.8497 48.1719 12.3443 54.1934 10.8389C48.1719 9.33352 46.6665 7.82815 45.1612 1.80664Z"
              stroke="#515151"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.03245 5.41943C7.58729 10.4775 6.86471 11.2001 1.80664 12.6452C6.86471 14.0904 7.58729 14.813 9.03245 19.871C10.4776 14.813 11.2002 14.0904 16.2583 12.6452C11.2002 11.2001 10.4776 10.4775 9.03245 5.41943Z"
              stroke="#515151"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icon.KITCHEN_FEATURES:
        return (
          <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 24.5H49M7 24.5V31.5V54.25M7 24.5V54.25M7 54.25H49M49 24.5V31.5V54.25M49 24.5V54.25"
              stroke="#515151"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14 47.25V35H42V47.25H14Z"
              stroke="#515151"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M23.625 1.75V5.25004L12.25 10.5V14H43.75V10.5L32.375 5.25004V1.75"
              stroke="#515151"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21 29.75H22.75"
              stroke="#515151"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M33.25 29.75H35"
              stroke="#515151"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icon.FLOORING:
        return (
          <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="3.5"
              y="3.5"
              width="49"
              height="49"
              rx="1.75"
              stroke="#515151"
              strokeWidth="2.5"
              strokeLinejoin="round"
            />
            <path d="M3.5 22.75L22.75 3.5" stroke="#515151" strokeWidth="2.5" />
            <path d="M3.86914 42.2305L42.2297 3.86993" stroke="#515151" strokeWidth="2.5" />
            <path d="M13.7676 52.1299L52.1281 13.7693" stroke="#515151" strokeWidth="2.5" />
            <path d="M32.9492 52.7485L52.7482 32.9495" stroke="#515151" strokeWidth="2.5" />
            <path d="M13.1523 13.1504L23.6267 23.6245" stroke="#515151" strokeWidth="2.5" />
            <path d="M35 10.5L45.5 21" stroke="#515151" strokeWidth="2.5" />
            <path d="M10.5 35L21 45.5" stroke="#515151" strokeWidth="2.5" />
            <path d="M33.25 33.25L42.8491 42.8494" stroke="#515151" strokeWidth="2.5" />
          </svg>
        );
      case Icon.LAYOUT_PREFS:
        return (
          <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.375 50.75H5.25V5.25H50.75V50.75H21.875"
              stroke="#515151"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M28 44.625V49.875"
              stroke="#515151"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M28 28V34.125"
              stroke="#515151"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M44.625 28H50.75"
              stroke="#515151"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.25 28H34.125"
              stroke="#515151"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case Icon.STYLE:
        return (
          <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.25 16.625L5.25 49L49 49"
              stroke="#515151"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M24.5 49V26.25H50.75V49"
              stroke="#515151"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M38.5 26.25L38.5 7.875"
              stroke="#515151"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2.625 16.625L40.25 7"
              stroke="#515151"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M42 49V38.5H33.25V49"
              stroke="#515151"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      default:
        return null;
    }
  }, [variant, color]);

  return <div className={className}>{getIcon()}</div>;
});

Icon.MOVE_IN_READY = prefsIds.moveInReady;
Icon.NEW_CONSTRUCTION = prefsIds.newConstruction;
Icon.KITCHEN_FEATURES = prefsIds.kitchenFeatures;
Icon.FLOORING = prefsIds.flooring;
Icon.STYLE = prefsIds.style;
Icon.LAYOUT_PREFS = prefsIds.layoutPrefs;

Icon.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
  color: PropTypes.string,
};

Icon.defaultProps = {
  className: '',
  variant: undefined,
  color: '',
};

export default Icon;
